import { Context } from '@/models/order-history/status/context/context'
import { OrderCancellationState } from '@spa/components/organisms/mypage/order/model/order-cancellation-state'
import { CreateOrderCancellationStateCommand } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/create-command'

/**
 * @internal モジュールの外部からはgetOrderCancellationStateを利用すること
 */
export class ForDefault extends CreateOrderCancellationStateCommand<Context> {
  shouldApply(_context: Context): _context is Context {
    return true
  }
  protected createState(context: Pick<Context, 'engineStatus'>): OrderCancellationState {
    const isCancellable = context.engineStatus === 'payment-done'

    return {
      isCancellable,
    }
  }
}
